import {
  ChevronUpIcon_default
} from "./chunk-XKR7R5D4.mjs";
export {
  ChevronUpIcon_default as default
};
